<template>
    <DFormRow
        :label="__('customers.contracts.start_date')"
        :error="errors.start_date"
        :is-required="required"
        :hint="!showHint ? __('customers.contracts.start_date_hint') : ''"
    >
        <DDateFormatInput
            id="contract_start_date"
            format="YYYY-MM-DD"
            :model-value="modelValue"
            :disabled="disabled === true"
            @update:modelValue="$emit('update:modelValue', $event)"
            @valueChanged="$emit('valueChanged')"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'StartDate',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        showHint: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: ['valueChanged', 'update:modelValue']
}
</script>
